export default (email: string) => {
  const emailRegex = /^[\w-\\.+]+@([\w-]+\.)+[\w-]{2,}$/g;
  return emailRegex.test(email);
};
